import { useDispatch } from "react-redux";
import { useMemo } from "react";
import Link from "next/link";
import Button from "/components/common/button";
import { popupTypes } from "/redux/reducers/popupReducer";
import { showPopup } from "/redux/action-creaters/popup";
import { setShowMobileMenu } from "/redux/action-creaters/pageState";
import Icon from "../../../common/icon";
import styles from "./index.module.scss";

export default function MobileMenu({ contacts }) {
  const dispatch = useDispatch();

  const phone = useMemo(() => {
    return contacts?.phone;
  }, [contacts]);

  return (
    <div className={styles.TopSections}>
      <ul className={styles.Links}>
        <li>
          <Link href="/catalog/">
            <a>
              <Icon fill={"#93979b"} size="18" id="catalog" />
              <span>Каталог</span>
            </a>
          </Link>
        </li>
        <li>
          <Link href="/faq/">Покупателям</Link>
        </li>
        <li>
          <Link href="/services/">Услуги</Link>
        </li>
        <li>
          <Link href="/delivery/">Доставка</Link>
        </li>
        <li>
          <Link href="/reviews/">Отзывы</Link>
        </li>
        <li>
          <Link href="/articles/">Статьи и новости</Link>
        </li>
        <li>
          <Link href="/partners/cooperation/">Партнерам</Link>
        </li>
        <li>
          <Link href="/about/">О компании</Link>
        </li>
        <li>
          <Link href="/contacts/">Контакты</Link>
        </li>
        <li>
          <Link href="/personal/cart/">
            <a>
              <Icon size="22" id="cart" customStyles={styles.CartIcon} />
              <span>Корзина</span>
            </a>
          </Link>
        </li>
        <li>
          <a
            onClick={() => {
              dispatch(setShowMobileMenu(false));
              dispatch(showPopup(popupTypes.locationNew));
            }}
          >
            <Icon fill={"#1247A5"} size="20" id="location" />
            <span style={{ color: "#1247A5" }}>Москва</span>
          </a>
        </li>
      </ul>

      <div className={styles.Soc}>
        <span>Мы в соцсетях</span>
        <div className={styles.SocList}>
          <Link href="https://vk.com/farkopru">
            <a target="_blank" rel="nofollow">
              <img src="/soc/3.svg"></img>
            </a>
          </Link>
          <Link href="https://rutube.ru/channel/33712357/">
            <a target="_blank" rel="nofollow">
              <img src="/soc/4.svg"></img>
            </a>
          </Link>
        </div>
      </div>

      <div className={styles.Info}>
        <a href="mailto:info@farkop.ru">info@farkop.ru</a>
        <a href={`tel:${phone}`} className={contacts?.calltouchCode}>
          {phone}
        </a>
      </div>
      <div className={styles.Button}>
        <Button
          onClick={() => {
            dispatch(setShowMobileMenu(false));
            dispatch(showPopup(popupTypes.backCall));
          }}
          label={"Заказать звонок"}
        />
      </div>
    </div>
  );
}
